import type { Address } from '@models/address.ts';
import { createApp } from 'vue';
import MapLocation from '@components/MapLocation.vue';

declare global {
  interface Window {
    address: Address
  }
}

export const initMapLocation = (): void => {
  if (!document.getElementById('static-google-map-app')) {
    return;
  }

  createApp(MapLocation, {
    address: window.address,
    circleOptions: {
      radius: 450,
    },
  }).mount('#static-google-map-app');
};
